export enum SupportedAppScreens {
    VROOME_APP = "Vroome App",
    CHAT = "Chat",
    VERIFICATIONS = "Verification",
}
